import { environment } from '@env/environment';

export const ApiPath = {
  signin: `${environment.apiUrl}/api/users/signin`,
  refreshToken: `${environment.apiUrl}/api/auth/tokens`,
  getAuthUsers: `${environment.apiUrl}/api/auth/users`,
};

export enum BranchTypeCode {
  AIR_LINE = 'AIR',
  ERP_PROVIDER = 'ERP',
  FREIGHT_FORWARDER = 'FWD',
  SHIPPER = 'OWN',
  RAIL = 'RAI',
  OCEAN_LINER = 'SHP',
  SERVICE_COMPANY = 'SRVC',
  TRUCKER = 'TRK',
  DEMO_COMPANY = 'DMO',
  WMS = 'WMS',
  INSURER = 'INSURER',
  CUSTOMS_BROKER = 'BROKER',
  EX_IMPORTER = 'EIP',
}

//#region 로그인 API 관련
export interface ILoginCondition {
  email: string;
  password: string;
}
export interface ILoginResult {
  userSeq: number;
  name: string;
  cellphone: string;
  directCall: string;
  email: string;
  accessToken: string;
  refreshToken: string;
  branchSeq: number;
  branchTypeCode: BranchTypeCode;
  lastLogin: boolean;
  userType: string;
  isAdmin: boolean;
}
//#endregion
